import { render, staticRenderFns } from "./sushi.vue?vue&type=template&id=e56f5938"
import script from "./sushi.vue?vue&type=script&lang=js"
export * from "./sushi.vue?vue&type=script&lang=js"
import style0 from "./sushi.vue?vue&type=style&index=0&id=e56f5938&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports